export default {
      id: "fleche_petite-usage",
      viewBox: "0 0 14 8",
      url: "../dist/images/" + "sprite.svg#fleche_petite-usage",
      toString: function () {
        return this.url;
      }
    }